import { module } from "angular";
import { TagComponent } from "./TagComponent";

module("mmGui").component("irTag", new TagComponent());
